import * as pagefind from '/pagefind/pagefind.js';

async function initPagefind() {
  const searchInput = document.querySelector('.js-search__input');
  const resultsContainer = document.querySelector('.SearchOverlay--results');
  const searchForm = document.querySelector('form');

  searchInput.addEventListener('input', async (e) => {
    const query = e.target.value.trim();
    if (query.length < 1) {
      resultsContainer.innerHTML = '';
      return;
    } else {
      const results = await pagefind.search(query);
      displayResults(results.results);
    }
  });

  searchForm.addEventListener('submit', (e) => e.preventDefault());
}

function displayResults(results) {
  const resultsContainer = document.querySelector('.SearchOverlay--results');
  if (!results.length) {
    resultsContainer.innerHTML = '<li>Keine Suchtreffer.</li>';
    return;
  }

  resultsContainer.innerHTML = '';

  results.forEach(async (result) => {
    const data = await result.data();
    const resultItem = document.createElement('li');
    
    const imageSrc = data.meta?.image?.replace('w=1600&h=800','w=960&h=640') || "";
    const figure = `
    <figure class="SearchResultItem--image--outer-container">
      <div class="SearchResultItem--image--inner-container">
        ${imageSrc ? `<img sizes="100vw" src="${imageSrc}" width="300" height="200" alt="">` : '<!---->'}
      </div>
    </figure>`;

    var plainTitle = data.meta?.title || '';
    var excerpt = data.excerpt || '';

    // Remove <mark> tags *only if they appear at the beginning*
    excerpt = excerpt.replace(/^<mark>(.*?)<\/mark>(.*)/, (_, marked, rest) => {
      return marked + rest;
    });

    if (excerpt.startsWith(plainTitle)) {
      excerpt = excerpt.slice(plainTitle.length).trim();
    }

    resultItem.innerHTML = `
      <a href="${data.url.replace('.html', '')}" class="SearchResultItem treatment">
        <div class="SearchResultItem--body">
          <div class="SearchResultItem--body--text">
            <h3>${data.meta?.title || 'Kein Titel'}</h3>
            <p class="SearchResultItem--body--text--description">
              ${excerpt}
            </p>
          </div>
          <span class="tertiary medium Button SearchResultItem--body--button">
            <span class="Button--label">Seite besuchen</span>
            <span class="Icon"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m10 16 4-4-4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
          </span>
        </div>
        ${figure}
      </a>
    `;
    resultsContainer.appendChild(resultItem);
  });
}

// Start Pagefind
initPagefind();
